import { render, staticRenderFns } from "./FormPenagihan.vue?vue&type=template&id=5fb7efd9&scoped=true"
import script from "./FormPenagihan.vue?vue&type=script&lang=js"
export * from "./FormPenagihan.vue?vue&type=script&lang=js"
import style0 from "./FormPenagihan.vue?vue&type=style&index=0&id=5fb7efd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb7efd9",
  null
  
)

export default component.exports